import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/iphone-new/discuss_banner.webp";
import { StaticImage } from "gatsby-plugin-image";

function Discussprojectios() {
  return (
    <section
      className="discussprojectios"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={5}
            lg={5}
            className="my-auto mt-4 mt-md-0 resp_order"
          >
            <StaticImage
              src="../../images/services-usa/iphone-new/discuss_ios.webp"
              alt="tekrevol_web"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={497}
              height={500}
            />
          </Col>
          <Col xs={12} md={6} lg={5} className="my-auto offset-lg-1">
            <h2 style={{ color: "#fff" }}>Want to Discuss your Project?</h2>
            <p style={{ color: "#fff" }}>
              We're here to listen and offer our insights. Schedule a free
              consultation and let's explore how we can work together.
            </p>
            <Link
              style={{ background: "#F47A1F", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Free Consultation!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Discussprojectios;
